module.exports = __webpack_public_path__ + "static/media/arrow_right_2_icon.2d411a3f.svg";